export default __webpack_public_path__ + "static/media/Jovian Faith Cape.8addc25d.jpg";